<app-payment-details
    [cartSplitByAwbAndFlight]="cartSplitByAwbAndFlight"
    [aboveThreshold]="aboveThreshold"
    [validateBeforeCartDeletion]="isNeededConfirmation"
    (cartDeleted)="deleteCart($event)"
></app-payment-details>
